<form [ngClass]="styles.searchWrapper">
	<vb-ui-search-input name="searchInput" [ngClass]="styles.search" ngModel [placeholder]="'Reports_Attendees_Column_SearchPlaceholder' | translate">
	</vb-ui-search-input>
</form>
<webcast-attendees-grid *ngIf="shouldInitialize" [getRows]="attendeesGetRow" [filterText]="searchText$ | async" [revConnectUseStatus]="revConnectUseStatus" [webcastId]="webcastId" [runNumber]="runNumber">
</webcast-attendees-grid>
